module.exports = __webpack_public_path__ + "static/media/reply.f22a67f0.svg";